var React = require('react');

function MoreIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("image",{"width":"96","height":"96","xlinkHref":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABHNCSVQICAgIfAhkiAAAASRJREFUeJzt2M1NxDAUhdFnKoAOKGFKoAPoBEqiA6ADSqAEOmA6uCwGJBYo85N4JE/OWUZ6nyw5lpxUAQAAAAAAAAAAAAAAAAAAo2lLB5Nsquq+qu6qavPz+KOq3qvqrbX2seZ+V0keM+0ryeNa+10ledmz+L9e1tbvKsnTEYv/9bSWfldJNicsPtkd582l9/e5mhuoqocT564PnB29P2mJDbjrPDt6f9Lsa2iSr9q9DafYttZuLrm/zxInYM4mHjI7en/SEhsw58PkkNnR+5OW2ID3zrOj9/v6ucZtT7jGbZPcXnr/LDL4h1Lv/lkkeT1i8a9r659Fdm/S1HHeZsabM3r/P71+Rz/U/79zn1trn2vuAwAAAAAAAAAAAAAAAAAA4/sGdfgFT5FF6cAAAAAASUVORK5CYII=","id":"img_1"})),React.createElement("use",{"xlinkHref":"#img_1","fill":"#FFFFFF","stroke":"none","transform":"scale(0.13541667 0.13541667)","key":1})]);
}

MoreIcon.defaultProps = {"width":"13px","height":"13px","viewBox":"0 0 13 13","version":"1.1"};

module.exports = MoreIcon;

MoreIcon.default = MoreIcon;
